// Static content for SolkSites. Edit here to update site content.

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Pricing", to: "/pricing" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: 2, suffix: "", label: "Projects in progress" },
  { value: 0, suffix: "", label: "Hidden fees" },
  { value: 14, suffix: " days", label: "Typical turnaround" },
  { value: 100, suffix: "%", label: "Client satisfaction" },
];

export const CLIENT_LOGOS = [
  "Website design", "Website redesign", "Domain management", "SEO foundations", "Easy to use platform", "Website maintenance", "Domain registration", "Form setups"
];

export const PROBLEMS = [
  {
    title: "Your website looks dated",
    desc: "Visitors judge trust, usually, within 17 - 50 milliseconds. An outdated site quietly costs you leads every single day.",
  },
  {
    title: "Enquiries are trickling in",
    desc: "You know the traffic is there — it just isn't converting into calls, quotes or booked appointments.",
  },
  {
    title: "Only built for desktop",
    desc: "Most visitors are on their phones - if the site isn't responsive, they can bounce steaight to a competitor.",
  },
  {
    title: "You're invisible on Google",
    desc: "Slow site loading? Incorrectly set security permission? No clear index structure? All reasons Google could be ranking you lower.",
  },
];

export const BENEFITS = [
  { icon: "Zap", title: "Fast turnaround", desc: "Most sites can launch in 2–3 weeks, not months of back-and-forth." },
  { icon: "Smartphone", title: "Mobile-first design", desc: "Every layout is designed for the phone first, then scaled up." },
  { icon: "Search", title: "SEO ready", desc: "Clean code, semantic HTML and technical foundations Google loves." },
  { icon: "Layers", title: "Modern tech stack", desc: "Built with the same technologies trusted by fast-growing startups." },
  { icon: "Settings2", title: "Easy to manage", desc: "Simple content updates, all managed through a personalised client portal." },
  { icon: "HeartHandshake", title: "Personal support", desc: "You get one point of contact who actually replies. Usually it's even same day." },
];

export const SERVICES = [ 
  {
    slug: "website-design",
    link: "oneoffpackages",
    icon: "LayoutTemplate",
    title: "Website Design",
    tagline: "A site that finally reflects the quality of your work.",
    shorts: {
      GBP: "Custom-designed, mobile-first websites that turn visitors into enquiries.",
      CAD: "Custom-designed, mobile-first websites that turn visitors into enquiries.",
    },
    hero_image: "/01-website-design.svg",
    benefits: [
      "Custom design — no cookie-cutter templates",
      "Mobile-first, blazing fast on any device",
      "Built for conversions, not just to look pretty",
      "SEO foundations baked in from day one",
    ],
    features: [
      "Unlimited page revisions during design",
      "Custom illustrations & photography direction",
      "Copywriting support included",
      "Analytics & conversion tracking setup",
      "One-year hosting included on all plans",
    ],
    who: "Growing businesses that have outgrown their DIY site and need something that actually competes.",
    process_note: "Most website design projects launch within 3 weeks of kickoff.",
  },
  {
    slug: "website-redesign",
    icon: "Repeat",
    link: "oneoffpackages",
    title: "Website Redesign",
    tagline: "Modernise without losing what already works.",
    shorts: {
      GBP: "A careful rebuild that preserves your SEO while dramatically lifting design and conversions.",
      CAD: "A careful rebuild that preserves your SEO while dramatically lifting design and conversions.",
    },
    hero_image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwd29ya3NwYWNlJTIwZGVza3xlbnwwfHx8fDE3ODMxMzQ2MjR8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Preserve your existing Google rankings",
      "Modernise design without a full rewrite",
      "Fix slow load times and mobile issues",
      "Clear before / after conversion tracking",
    ],
    features: [
      "Full audit of your current site",
      "301 redirect strategy to protect SEO",
      "Modern design system rebuilt from scratch",
      "Performance & accessibility overhaul",
    ],
    who: "Established businesses with an ageing site that still ranks — but no longer converts.",
    process_note: "Redesigns typically go live within 3–4 weeks.",
  },
  {
    slug: "website-care",
    icon: "ShieldCheck",
    link: "carepackages",
    title: "Website Care plans",
    tagline: "Ongoing support, updates and security for your site.",
    shorts: {
      GBP: "Peace of mind that your website is always up-to-date, secure and performing at its best.",
      CAD: "Peace of mind that your website is always up-to-date, secure and performing at its best.",
    },
    hero_image: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBkaXZlcnNlJTIwdGVhbSUyMG1lZXRpbmclMjBhZ2VuY3l8ZW58MHx8fHwxNzgzMTM0NjI0fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Answers every visitor instantly, day or night",
      "Trained on your services, prices and policies",
      "Qualifies leads before they reach you",
      "Books calls straight into your calendar",
    ],
    features: [
      "Custom knowledge base from your documents",
      "Natural, on-brand conversation style",
      "CRM & calendar integration",
      "Weekly reports on visitor conversations",
    ],
    who: "Any business getting 100+ website visits a week and losing enquiries after hours.",
    process_note: "Chatbots go live within 7–10 days.",
  },
  {
    slug: "domain-management",
    icon: "Globe2",
    title: "Domain management",
    tagline: "Registering, or just hosting? We got you.",
    shorts: {
      GBP: "Starting from £30",
      CAD: "Starting from CA$59",
    },
    hero_image: "/04-domain-management.svg",
    benefits: [
      "Domain registration handled, with SSL certificate",
      "Updates to DNS records and email routing managed for you",
      "Renewal management so you never lose your domain",
      "Site file uploads to ensure your site is always up to date"
    ],
    features: [
      "The domain you want, with the security you need",
      "A custom email ending with your domain for customers to contact you with",
      "A reminder when your plan is nearly over so we can renew and sort it in plenty of time",
      "Website files change? We can upload them for you as long as you provide them"
    ],
    who: "Trades, clinics, salons and restaurants who lose bookings when the phone rings unanswered.",
    process_note: "Voice agents launch within 2 weeks.",
  },
  {
    slug: "custom-email",
    icon: "Mail",
    title: "Custom email setup",
    tagline: "A dedicated address your customers can reach you",
    shorts: {
      GBP: "Starting from £50",
      CAD: "Starting from CA$99",
    },
    hero_image: "05-custom-email.svg",
    benefits: [
      "you@yourdomain address to use across the web",
      "Multiple email addresses for different departments",
      "Email signature set-up per account",
    ],
    features: [
      "Custom emails for any person or department",
      "Different addresses for different categories of emails",
      "Make your emails look more professional",
    ],
    who: "Owner-operators who are the bottleneck — because everything still runs through them.",
    process_note: "Most automations are live within 10 days.",
  },
];

export const ONE_OFF_PACKAGES = {
  heading: "Our one-off package comparison",
  description: "A quick snapshot of what’s included across our most popular website build packages.",
  badge: "Custom scopes available",
  columns: ["Launch", "Growth", "Expand"],
  rows: [
    {
      label: "Cost",
      help: false,
      helpText: "The starting price for this package and what you can expect to invest at launch.",
      values: ["£299", "£399", "£599"],
    },
    {
      label: "Pages included",
      help: true,
      helpText: "How many custom pages the package covers, from the main homepage through to key service or about pages.",
      values: ["3", "5", "8"],
    },
    {
      label: "Mobile optimisation",
      help: true,
      helpText: "Your site will be designed to work beautifully on phones, tablets and smaller screens.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "Website deployment",
      help: true,
      helpText: "This covers getting the site live on a custom domain. Domain registration is separate.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "Contact forms",
      help: true,
      helpText: "Forms that allow visitors to get in touch, request a quote or book an appointment.",
      values: ["1", "2", "2"],
    },
    {
      label: "Google Maps integration",
      help: true,
      helpText: "Integration with Google Maps for location-based services and directions.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "SEO setup",
      help: true,
      helpText: "Basic on-page SEO setup, including meta tags, alt text, and sitemap submission to search engines.",
      values: ["Basic", "Standard", "Advanced"],
    },
    {
      label: "Revision rounds",
      help: true,
      helpText: "The number of rounds of revisions included in the package, allowing for feedback and adjustments to the design.",
      values: ["1", "2", "2"],
    },
    {
      label: "Eligible for care plans",
      help: false,
      values: ["✅", "✅", "✅"],
    },
  ],
};

export const CARE_PACKAGES = {
  heading: "Our care package comparison",
  description: "A clear overview of the ongoing support and maintenance included in each care plan.",
  badge: "Flexible add-ons available",
  columns: ["Essential Care", "Business Care", "Premium Care"],
  rows: [
    {
      label: "Monthly cost",
      help: false,
      helpText: "The recurring monthly investment for each care plan.",
      values: ["£29", "£49", "£89"],
    },
    {
      label: "Content changes included",
      help: true,
      helpText: "The amount of time included each month for small website updates such as text or layout edits.",
      values: ["15 mins", "30 mins", "60 mins"],
    },
    {
      label: "Text updates",
      help: true,
      helpText: "Simple content edits like changing headlines, copy or button text.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "Image changes",
      help: true,
      helpText: "Replacing imagery, updating banners or swapping product or team photos.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "Broken link checks",
      help: true,
      helpText: "We review the site for dead links, missing pages and broken navigation.",
      values: ["❌", "✅", "✅"],
    },
    {
      label: "Backups",
      help: true,
      helpText: "How often your website is backed up to keep your content safe.",
      values: ["Monthly", "Weekly", "Daily"],
    },
    {
      label: "Backup restoration",
      help: false,
      helpText: "Whether we can restore your site quickly from a backup if anything goes wrong.",
      values: ["✅", "✅", "✅"],
    },
    {
      label: "Priority support",
      help: true,
      helpText: "A faster response path for urgent requests or time-sensitive changes.",
      values: ["❌", "✅", "✅"],
    },
    {
      label: "Response target time",
      help: true,
      helpText: "The expected turnaround for support requests under each care plan.",
      values: ["3 business days", "2 business days", "1 business day"],
    },
    {
      label: "Analytics reporting",
      help: true,
      helpText: "Regular insight into how visitors are using the site and what is driving enquiries.",
      values: ["❌", "Quarterly", "Monthly"],
    },
    {
      label: "Website health check",      help: true,      helpText: "A review of the site’s performance, usability and technical condition.",
      values: ["Quarterly", "Monthly", "Monthly"],
    },
    {
      label: "SEO health checks",
      help: true,
      helpText: "Periodic checks for on-page SEO issues and search visibility improvements.",
      values: ["❌", "Quarterly", "Monthly"],
    },
    {
      label: "Uptime monitoring",
      help: true,
      helpText: "Keeping an eye on availability so your website stays online and reliable.",
      values: ["❌", "✅", "✅"],
    },
    {
      label: "Discount on future work",
      help: false,
      helpText: "A percentage discount applied to future design or development work after launch.",
      values: ["5%", "10%", "15%"],
    },
  ],
};

export const WHY_US = [
  { icon: "Sparkles", title: "Custom, never templated", desc: "Every site is designed from scratch for your business — not adapted from a theme." },
  { icon: "Gauge", title: "Built for speed", desc: "85+ Lighthouse scores as standard. Slow sites lose customers." },
  { icon: "Users", title: "Real, plain English", desc: "No jargon. No 40-page reports. Just clear conversations and results." },
  { icon: "Rocket", title: "Live in weeks, not months", desc: "A defined process means projects don't drag. Ever." },
  { icon: "DollarSign", title: "Transparent pricing", desc: "No hidden fees, or surprise costs - one price from the start." },
  { icon: "HandshakeIcon", title: "One point of contact", desc: "You'll talk to the person actually building your site." },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Discover", desc: "A 30-minute call to understand your business, goals and where the friction is." },
  { step: "02", title: "Plan", desc: "A clear proposal with fixed scope, fixed price and a launch date on the calendar." },
  { step: "03", title: "Design", desc: "Custom design mocks delivered in week one — with room for feedback and iteration." },
  { step: "04", title: "Build", desc: "We build in the open. You'll see progress every few days on a live staging URL." },
  { step: "05", title: "Launch", desc: "A calm, checklisted launch day. No surprises, no downtime." },
  { step: "06", title: "Support", desc: "Ongoing support, maintenance and small tweaks — for as long as you need us." },
];

export const TESTIMONIALS = [
  {
    quote: "Booked calls doubled in the first six weeks. The new site finally matches how good my work actually is.",
    name: "Sarah Whitmore",
    role: "Founder, Whitmore Dental",
    avatar: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?w=200&h=200&fit=crop",
  },
  {
    quote: "The AI voice agent picks up every out-of-hours call and books them straight into my diary. It's uncanny how good it is.",
    name: "James O'Connor",
    role: "Director, Ironmark Trades",
    avatar: "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?w=200&h=200&fit=crop",
  },
  {
    quote: "Calm, confident, no drama. They just built exactly what we asked for, on time, and it works beautifully.",
    name: "Priya Anand",
    role: "Owner, Fernrock Coffee",
    avatar: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=200&h=200&fit=crop",
  },
  {
    quote: "We spent two years and two agencies trying to fix our old site. SolkSites replaced it in 3 weeks. Enquiries up 60%.",
    name: "Michael Boateng",
    role: "MD, Northlane Estates",
    avatar: "https://images.pexels.com/photos/7057/desk-office-computer-imac.jpg?w=200&h=200&fit=crop",
  },
];

export const PRICING_TIERS = [
  {
    name: "Starter",
    price: "£1,950",
    cadence: "one-off",
    tagline: "For solo operators launching properly for the first time.",
    features: [
      "Up to 5 custom pages",
      "Mobile-first responsive design",
      "Contact form & lead capture",
      "Basic SEO foundations",
      "1 round of revisions",
      "Launch in 2 weeks",
    ],
    highlight: false,
    cta: "Book a call",
  },
  {
    name: "Professional",
    price: "£3,950",
    cadence: "one-off",
    tagline: "The sweet spot for most growing businesses.",
    features: [
      "Up to 10 custom pages",
      "Copywriting support included",
      "Blog & CMS setup",
      "Full SEO foundations",
      "Google Analytics & Search Console",
      "3 rounds of revisions",
      "Launch in 3 weeks",
    ],
    highlight: true,
    cta: "Book a call",
  },
  {
    name: "Growth",
    price: "£6,950",
    cadence: "one-off",
    tagline: "For businesses ready to add AI and automation.",
    features: [
      "Everything in Professional",
      "AI chatbot trained on your business",
      "CRM integration",
      "Booking / calendar automation",
      "Custom lead workflows",
      "Priority support for 90 days",
    ],
    highlight: false,
    cta: "Book a call",
  },
  {
    name: "Enterprise",
    price: "Let's talk",
    cadence: "custom",
    tagline: "Multi-location, multi-brand or custom platform builds.",
    features: [
      "Custom scope & timeline",
      "AI voice agents",
      "Multi-site architecture",
      "Bespoke integrations",
      "Dedicated project lead",
      "SLA & priority support",
    ],
    highlight: false,
    cta: "Talk to us",
  },
];

export const FAQS = [
  {
    category: "Pricing",
    q: "How much does a website really cost?",
    a: "Our one-off website packages start from £299/CA$499, with custom builds priced based on scope. You'll always get a clear quote before we start — no scope creep, no surprises.",
  },
  {
    category: "Pricing",
    q: "Do you offer payment plans?",
    a: "We don't currently offer installment payment plans — projects are paid in full. If that's a barrier, get in touch and we can talk through options.",
  },
  {
    category: "Timeline",
    q: "How long does a website take?",
    a: "Most sites launch within 2–3 weeks from kickoff, depending on scope and how quickly we get feedback from you.",
  },
  {
    category: "Timeline",
    q: "What do you need from me to get started?",
    a: "A quick discovery call, a rough idea of what you like design-wise, and access to your current site or brand assets if you have them. That's it.",
  },
  {
    category: "Process",
    q: "Do you use templates?",
    a: "No. Every site is designed from scratch, tailored to your business — not a pre-built template.",
  },
  {
    category: "Support",
    q: "What happens after launch?",
    a: "We offer three tiers of website care plans starting from £29/CA$49/month, covering things like updates, backups, security and small edits — so your site stays running smoothly.",
  },
  {
    category: "Support",
    q: "Who owns the website?",
    a: "You do. Once your project is paid in full, you fully own your site and code — regardless of whether you're on a care plan. If you ever cancel your care plan, you keep full ownership; we'll talk you through your hosting options at that point, whether that's moving to your own hosting or another provider, so you can keep everything running without interruption.",
  },
];

export const PORTFOLIO = [
  {
    slug: "yummy-treats-2021",
    title: "Yummy Treats",
    category: "Website Creation",
    tags: [],
    year: "2021",
    link: "https://yummy-treats.com",
    cover: "/yummy-treats-cover.png",
    intro: "A clean, easy to navigate website for a home-baking business",
    overview: "Yummy Treats was a local home-baking business wanting to improve their online presence past social media. The owner needed a site to showcase her amazing talent and passion for baking.",
    objectives: [
      "Allow customers to view their work online",
      "Create an easy inquiry form to improve orders",
      "One place to view all business information",
    ],
    solution: "A clean, modern and aesthetic website with easily navigable showcase work along with instant access to social media and inquiry forms.",
    tech: ["HTML", "CSS", "JavaScript", "FormSubmit"],
    results: [
      { value: "+112%", label: "New patient bookings" },
      { value: "3.2s → 0.9s", label: "Load time" },
      { value: "40%", label: "Enquiries handled by AI" },
    ],
    testimonial: {
      quote: "Booked calls doubled in the first six weeks. The new site finally matches how good my work actually is.",
      name: "Sarah Whitmore",
      role: "Founder, Whitmore Dental",
    },
  },
  {
    slug: "solk-sites-2026",
    title: "Solk Sites",
    category: "Website Creation",
    tags: [],
    year: "2026",
    link: "https://solksites.com",
    cover: "/solk-sites-cover.png",
    intro: "Our very own website, built to showcase our services and expertise",
    overview: "Solk Sites is a web design and development agency that helps businesses establish a strong online presence. We create beautiful, functional websites that drive results.",
    objectives: [
      "Create an accessible website to showcase our services and work",
      "Allow an easy way for potential clients to get in touch",
      "Give clear pricing to all customers, matched to the goals they have in mind",
    ],
    solution: "A modern website that allows users to seamlessly interact with our services, view our portfolio, and get in touch with us. The site is designed to be fast, responsive, and easy to navigate.",
    tech: ["React", "Tailwind CSS", "JavaScript", "Web3Forms"],
    results: [
      { value: "+112%", label: "New patient bookings" },
      { value: "3.2s → 0.9s", label: "Load time" },
      { value: "40%", label: "Enquiries handled by AI" },
    ],
    testimonial: {
      quote: "Booked calls doubled in the first six weeks. The new site finally matches how good my work actually is.",
      name: "Sarah Whitmore",
      role: "Founder, Whitmore Dental",
    },
  }
];

export const BLOG_POSTS = [
  {
    slug: "why-your-website-isnt-converting",
    title: "Why your website isn't converting (and 5 things to fix this week)",
    excerpt: "The five most common reasons a business site quietly leaks leads — and how to fix them without a full rebuild.",
    category: "Website",
    date: "2025-11-14",
    read: "6 min read",
    cover: "https://images.pexels.com/photos/7057/desk-office-computer-imac.jpg?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
  {
    slug: "ai-chatbots-that-actually-help",
    title: "AI chatbots that actually help (and the ones that annoy)",
    excerpt: "A practical field guide to setting up an AI chatbot your customers will thank you for.",
    category: "AI",
    date: "2025-11-02",
    read: "8 min read",
    cover: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
  {
    slug: "the-3-week-website",
    title: "The 3-week website: how we deliver fast without cutting corners",
    excerpt: "A behind-the-scenes look at the process that lets us launch premium sites in a fraction of the time.",
    category: "Process",
    date: "2025-10-18",
    read: "5 min read",
    cover: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
  {
    slug: "local-seo-cheatsheet",
    title: "The local SEO cheatsheet for small businesses in 2026",
    excerpt: "The exact steps we take to get local businesses into the Google map pack — without gimmicks.",
    category: "SEO",
    date: "2025-10-05",
    read: "7 min read",
    cover: "https://images.pexels.com/photos/15863044/pexels-photo-15863044.jpeg?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
  {
    slug: "automate-your-admin",
    title: "Automate your admin: 7 workflows every small business needs",
    excerpt: "Simple, safe automations that quietly save 10+ hours a week — no engineering degree required.",
    category: "Automation",
    date: "2025-09-22",
    read: "9 min read",
    cover: "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
  {
    slug: "premium-without-the-price-tag",
    title: "How to look premium without the £20k price tag",
    excerpt: "Design principles from the world's best-looking sites, applied to small business budgets.",
    category: "Website",
    date: "2025-09-04",
    read: "6 min read",
    cover: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?w=1200&h=800&fit=crop",
    author: "Solk Editorial",
  },
];

export const VALUES = [
  { title: "Craft over cliché", desc: "We'd rather ship one beautiful page than five average ones." },
  { title: "Plain English, always", desc: "If we can't explain it clearly, we don't understand it well enough." },
  { title: "Show, don't sell", desc: "The work speaks first. We just make sure it can be heard." },
  { title: "Speedy replies", desc: "You're not a ticket. You'll always talk to a real person, quickly." },
];

export const TIMELINE = [
  { year: "2021", title: "Solk begins", desc: "Founded as a two-person studio helping local businesses look as good online as they were in person." },
  { year: "2022", title: "First 25 sites", desc: "A quiet reputation for calm, on-time launches starts spreading through word of mouth." },
  { year: "2023", title: "Automation practice", desc: "We start bundling automation and CRM work — reclaiming evenings for the owners who hired us." },
  { year: "2024", title: "AI voice launch", desc: "Voice agents go into production. Missed-call revenue is quietly returned to a dozen clients." },
  { year: "2025", title: "100+ launches", desc: "We cross 100 launched projects. Same principles, same team, same reply-the-same-day promise." },
];

export const BUDGET_OPTIONS = [
  { value: "under_500", label: { GBP: "Under £500", CAD: "Under CA$700" } },
  { value: "between_500_750", label: { GBP: "£500 – £750", CAD: "CA$700 – $1,000" } },
  { value: "between_750_1000", label: { GBP: "£750 – £1,000", CAD: "CA$1,000 – $1,500" } },
  { value: "over_1000", label: { GBP: "£1,000+", CAD: "CA$1,500+" } },
];
